import React, { useState, useEffect } from 'react';
import { Table, Button, Pagination, PaginationItem, PaginationLink, Form, FormGroup, Label, Input } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import EditQuotaForm from './EditQuotaForm';
import CreateQuotaForm from './CreateQuotaForm';
import { quotas as staticQuotas } from './data'; // Ensure you fetch projects
import projectsService from "../../services/api/projects-service";

const QuotaList = () => {
  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [selectedQuota, setSelectedQuota] = useState(null);
  const [filteredQuotas, setFilteredQuotas] = useState(staticQuotas);
  const [projectIdFilter, setProjectIdFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [quotaToDelete, setQuotaToDelete] = useState(null);

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = page * itemsPerPage;
  const paginatedQuotas = filteredQuotas.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredQuotas.length / itemsPerPage);
  const [staticProjects,setProjectNames] = useState([]);

  useEffect( () => {
    (async () =>{
        // if(publisher){
            let projects = await projectsService.getPublisherProjects();
            let publisherProjects = [];
            if(projects.status){
                let projectData = projects.data;
                if(projectData.length){
                    projectData.forEach(function(projectDetails) {
                        let projectValue = {value:projectDetails.id,label:`${projectDetails.name} (${projectDetails.slug})`};
                        publisherProjects.push(projectValue)
                    })
                }
                console.log("publisherProjects",publisherProjects);
                setProjectNames(publisherProjects);
            }
        // }
    })();
  }, []);

  const handleSave = (quota) => {
    if (quota._id) {
      // Update existing quota
      const index = filteredQuotas.findIndex(q => q.value === quota.value);
      if (index >= 0) {
        filteredQuotas[index] = quota;
      }
    } else {
      // Add new quota
      filteredQuotas.push(quota);
    }
    setFilteredQuotas([...filteredQuotas]);
    setShowAlert(false); // Close the SweetAlert
  };

  const handleDelete = (id) => {
    setQuotaToDelete(id);
    setAlertType('delete');
    setAlertTitle('Are you sure?');
    setAlertMessage('You won\'t be able to revert this!');
    setShowAlert(true);
  };

  const confirmDelete = () => {
    const updatedQuotas = filteredQuotas.filter(q => q._id !== quotaToDelete);
    setFilteredQuotas(updatedQuotas);
    setQuotaToDelete(null);
    setShowAlert(false);
  };

  const handleFilter = () => {
    const filtered = staticQuotas.filter(q => {
      return (
        (projectIdFilter === '' || q.project_id.includes(projectIdFilter)) &&
        (statusFilter === '' || (statusFilter === 'active' ? q.status === 1 : q.status === 0))
      );
    });
    setFilteredQuotas(filtered);
    setPage(1); // Reset to first page after filtering
  };

  const handleResetFilter = () => {
    setProjectIdFilter('');
    setStatusFilter('');
    setFilteredQuotas(staticQuotas);
    setPage(1); // Reset to first page after resetting filters
  };

  const openEditDialog = (quota) => {
    setSelectedQuota(quota);
    setAlertType('edit');
    setAlertTitle('Edit Quota');
    setShowAlert(true);
  };

  const openCreateForm = () => {
    setSelectedQuota(null);
    setAlertType('create');
    setAlertTitle('Create Quota');
    setShowAlert(true);
  };

  const handleAlertConfirm = () => {
    if (alertType === 'edit' && selectedQuota) {
      handleSave(selectedQuota);
    } else if (alertType === 'create') {
      // Create form will be handled by its own submit button
    } else if (alertType === 'delete') {
      confirmDelete();
    }
    setShowAlert(false);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Quotas</h2>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <Form inline style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FormGroup>
            <Label for="projectIdFilter" style={{ marginRight: '5px' }}>Project</Label>
            <Input
              type="select"
              id="projectIdFilter"
              value={projectIdFilter}
              onChange={(e) => setProjectIdFilter(e.target.value)}
              style={{ width: '150px' }}
            >
              <option value="">Select Project</option>
              {staticProjects.map(project => (
                <option key={project.value} value={project.value}>
                  {project.label}
                </option>
              ))}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="statusFilter" style={{ marginRight: '5px' }}>Status</Label>
            <Input
              type="select"
              id="statusFilter"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{ width: '150px' }}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Input>
          </FormGroup>
          <Button color="primary" onClick={handleFilter} style={{ marginRight: '10px' }}>Apply</Button>
          <Button color="secondary" onClick={handleResetFilter}>Reset</Button>
        </Form>
        <Button color="success" onClick={openCreateForm}>Add Credits</Button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
        <Pagination>
          <PaginationItem disabled={page <= 1}>
            <PaginationLink first onClick={() => page > 1 && handlePageChange(1)} />
          </PaginationItem>
          <PaginationItem disabled={page <= 1}>
            <PaginationLink previous onClick={() => page > 1 && handlePageChange(page - 1)} />
          </PaginationItem>
          {[...Array(totalPages).keys()].map(number => (
            <PaginationItem active={number + 1 === page} key={number + 1}>
              <PaginationLink onClick={() => handlePageChange(number + 1)}>
                {number + 1}
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem disabled={page >= totalPages}>
            <PaginationLink next onClick={() => page < totalPages && handlePageChange(page + 1)} />
          </PaginationItem>
          <PaginationItem disabled={page >= totalPages}>
            <PaginationLink last onClick={() => page < totalPages && handlePageChange(totalPages)} />
          </PaginationItem>
        </Pagination>
      </div>
      <Table striped bordered hover style={{ marginBottom: '20px' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Project</th>
            <th>Status</th>
            <th>Total Quota</th>
            <th>Quota Used</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedQuotas.map(quota => (
            <tr key={quota._id}>
              <td>{quota._id}</td>
              <td>{quota.project_id}</td>
              <td>{quota.status === 1 ? 'Active' : 'Inactive'}</td>
              <td>{quota.total_quota}</td>
              <td>{quota.quota_used}</td>
              <td>
                <Button
                  color="info"
                  onClick={() => openEditDialog(quota)}
                  style={{ background: 'none', border: 'none', padding: '0' }}
                >
                  <svg
                    width="24"
                    height="24"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: 'blue' }} // Change color here
                  >
                    <path d="M14.06 2.94a1.5 1.5 0 0 1 2.12 0l1.88 1.88a1.5 1.5 0 0 1 0 2.12l-9.7 9.7a1.5 1.5 0 0 1-.53.32L4 19.75a1.5 1.5 0 0 1-1.5-1.5V15.75c0-.28.07-.55.21-.79l7.2-7.2a1.5 1.5 0 0 1 .32-.53l9.7-9.7zM13 7.59l-5.83 5.83L5 14.33v2.92l2.75-2.75 5.83-5.83 2.75 2.75-5.83 5.83-2.75 2.75v-2.92L13 7.59z"/>
                  </svg>
                </Button>
                <Button
                  color="danger"
                  onClick={() => handleDelete(quota._id)}
                  style={{ background: 'none', border: 'none', padding: '0' }}
                >
                  <svg
                    width="24"
                    height="24"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: 'red' }} // Change color here
                  >
                    <path d="M6 21c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v14zm11.5-16h-1.5V2h-6v3H5.5v2h11V5z"/>
                  </svg>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showAlert && (
        <SweetAlert
          show={showAlert}
          title={alertTitle}
          type={alertType === 'edit' ? 'info' : alertType === 'create' ? 'success' : 'warning'}
          showCancel
          confirmButtonText={alertType === 'edit' || alertType === 'create' ? 'OK' : 'Yes, delete it!'}
          cancelButtonText="Cancel"
          onConfirm={handleAlertConfirm}
          onCancel={() => setShowAlert(false)}
          style={{ padding: 0, border: 'none', boxShadow: 'none' }} // Inline styles to hide icon
        >
          {alertType === 'edit' && <EditQuotaForm quota={selectedQuota} projects={staticProjects} onSave={handleSave} onClose={() => setShowAlert(false)} />}
          {alertType === 'create' && <CreateQuotaForm projects={staticProjects} onSave={handleSave} onClose={() => setShowAlert(false)} />}
          {alertType === 'delete' && <p>{alertMessage}</p>}
        </SweetAlert>
      )}
    </div>
  );
};

export default QuotaList;
